import React, { useState, useEffect } from 'react'
import Sidebar from '../../components/Admin/Sidebar'
import AdminHeader from '../../components/Admin/AdminHeader'
import useGroupsStore from '../../stores/groupsStore'
import { useNavigate } from 'react-router-dom';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

function AdminGroups() {
  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [showStudents, setShowStudents] = useState(null); // id группы для просмотра студентов
  const {
    groups, fetchGroups, addGroup, deleteGroup, getGroup, addResult, loading, error, clearAddResult, reorderGroups
  } = useGroupsStore();
  const [localOrder, setLocalOrder] = useState([]);
  const [dragId, setDragId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const [displayed, setDisplayed] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [search, setSearch] = useState(''); // состояние поиска
  const navigate = useNavigate();

  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLocalOrder((groups || []).map((g, idx) => ({ id: g._id, order: g.order ?? idx })));
    setDisplayed((groups || []).slice());
  }, [groups]);

  useEffect(() => {
    // при поиске отображаем только подходящие, но порядок берём из displayed
    if (!search.trim()) {
      setDisplayed((prev) => (prev.length ? prev : (groups || []).slice()));
    } else {
      setDisplayed((groups || []).filter(g => g.name && g.name.toLowerCase().includes(search.trim().toLowerCase())));
    }
  }, [search, groups]);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addGroup({ name });
      setName('');
    } catch {}
  };

  const handleShowStudents = async (groupId) => {
    setStudentsLoading(true);
    try {
      const group = await getGroup(groupId);
      setStudents(group.students || []);
      setShowStudents(groupId);
    } catch {
      setStudents([]);
      setShowStudents(groupId);
    } finally {
      setStudentsLoading(false);
    }
  };

  return (
    <div className='AdminGroups'>
        <div className="AdminGroups__container">
        <Sidebar className="admin-sidebar" />
            <div className="content_admin">
                <AdminHeader
                    title="Управление группами"
                    textButton="Добавить группу"
                    onButtonClick={() => { setModalOpen(true); clearAddResult(); setName(''); }}
                />
          <div className="search admin-groups-search">
            <input
              type="text"
              placeholder='Поиск группы'
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ width: 260 }}
            />
                </div>
                <div className="admin-groups-table-wrapper">
                  <table className="admin-groups-table">
                    <thead>
                      <tr>
                        <th>Название группы</th>
                        <th className="center">Кол-во обучающихся</th>
                        <th className="center">Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading && (
                  <tr><td colSpan={3} className="admin-groups-table-loading">Загрузка...</td></tr>
                      )}
                {!loading && groups.filter(g => g.name && g.name.toLowerCase().includes(search.trim().toLowerCase())).length === 0 && (
                  <tr><td colSpan={3} className="admin-groups-table-empty">Нет групп</td></tr>
                      )}
                {!loading && (displayed || []).map(g => (
                  <React.Fragment key={g._id}>
                  {dragOverId === g._id && (
                    <tr className="admin-groups-drop-indicator"><td colSpan={3}></td></tr>
                  )}
                  <tr className="admin-groups-table-row"
                      draggable
                      onDragStart={(e) => { setDragId(g._id); e.dataTransfer.effectAllowed = 'move'; }}
                      onDragOver={e => { e.preventDefault(); setDragOverId(g._id); }}
                      onDragLeave={() => { /* optional */ }}
                      onDrop={() => {
                        if (!dragId || dragId === g._id) return;
                        // Переставляем в полном списке, чтобы порядок был глобальным
                        const full = [ ...(groups || []) ];
                        const fromFull = full.findIndex(x => x._id === dragId);
                        const toFull = full.findIndex(x => x._id === g._id);
                        const [movedFull] = full.splice(fromFull, 1);
                        full.splice(toFull, 0, movedFull);

                        // Обновляем отображаемый список
                        if (!search.trim()) setDisplayed(full);
                        else setDisplayed(full.filter(x => x.name && x.name.toLowerCase().includes(search.trim().toLowerCase())));

                        const orders = full.map((x, idx) => ({ id: x._id, order: idx }));
                        setLocalOrder(orders);
                        setDragOverId(null);
                        setDragId(null);
                        // Автосохранение порядка
                        (async () => {
                          try {
                            await reorderGroups(orders);
                            await fetchGroups();
                          } catch (_) {}
                        })();
                      }}
                  >
                    <td className="admin-groups-table-name">{g.name}</td>
                    <td className="admin-groups-table-count center">{g.students ? g.students.length : 0}</td>
                    <td className="admin-groups-table-actions center">
                      <button className="admin-groups-btn admin-groups-btn-secondary" onClick={() => navigate(`/admin/groups/${g._id}`)}>Подробнее</button>
                    </td>
                  </tr>
                  </React.Fragment>
                ))}
                    </tbody>
                  </table>
                </div>
            </div>
        </div>
        {modalOpen && (
        <div className="admin-groups-modal-overlay">
          <div className="admin-groups-modal-content">
            <h3 className="admin-groups-modal-title">Добавить группу</h3>
              <form onSubmit={handleAdd}>
              <div className="admin-groups-modal-field">
                  <label>Название группы:</label>
                <input value={name} onChange={e => setName(e.target.value)} required />
                </div>
              {error && <div className="admin-groups-modal-error">{error}</div>}
                {addResult && (
                <div className="admin-groups-modal-success">
                    <div><b>Группа создана:</b> {addResult.name}</div>
                  </div>
                )}
              <div className="admin-groups-modal-actions">
                <button type="button" className="admin-groups-modal-btn" onClick={() => { setModalOpen(false); clearAddResult(); }}>Отмена</button>
                <button type="submit" className="admin-groups-modal-btn admin-groups-modal-btn-primary" disabled={loading}>{loading ? 'Добавление...' : 'Добавить'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
      <AdminBottomNavBar />
    </div>
  )
}

export default AdminGroups